import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';

export const getAllErrors = (form: UntypedFormGroup | UntypedFormArray) => {
  let hasError = false;
  const result = Object.keys(form.controls).reduce((acc, key) => {
    const control = form.get(key);
    const errors =
      control instanceof UntypedFormGroup || control instanceof UntypedFormArray
        ? getAllErrors(control)
        : control.errors;
    if (errors) {
      acc[key] = errors;
      hasError = true;
    }
    return acc;
  }, {} as { [key: string]: any });
  return hasError ? result : null;
};
